import React, { useEffect, useState } from "react";
import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import FileUploader from "components/MediaTel/FileUploader";
import FileViewer from "components/MediaTel/FileViewer";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Button from "@mui/material/Button";
import Loader from "components/Loading/Loader";
import classnames from "classnames";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  appdataSelector,
  appdata_getPOsForVendor,
  appdata_getVendorsForCompany,
  appdata_setActiveRequestState,
  appdata_setActiveRequestType,
  appdata_setSnackbar
} from "reducers/appdata/appdata";
import {
  vendor_save_to_sap,
  vendordataSelector,
  vendordata_clearAllVendorData,
  vendordata_setSavedToSAP,
  vendordata_updateActiveVendor
} from "reducers/vendordata/vendordata";
import Feedback from "../../partials/Feedback";

function Extend() {
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();

  const [fromCompanySelected, setFromCompanySelected] = useState("");
  const [toCompanySelected, setToCompanySelected] = useState("");
  const [vendorSelected, setVendorSelected] = useState("");
  const [fromPOSelected, setFromPOSelected] = useState("");
  const [kindOfChange, setKindOfChange] = useState("");

  useEffect(() => {
    console.log("NEW Change");

    if (!appdata.isResetRequest) {
      dispatch(vendordata_clearAllVendorData());
    }

    if (appdata.activeRequestState != appdata.requestStates.CREATE) {
      dispatch(appdata_setActiveRequestState(appdata.requestStates.CREATE));
    }

    if (vendordata.savedToSAP) {
      dispatch(vendordata_setSavedToSAP(false));
    }
  }, []);

  useEffect(() => {

    if (vendordata && vendordata.activeVendor && vendordata.activeVendor.master) {
      if (appdata && appdata.listvalues) {

        if (appdata.listvalues.companyDropdownValues) {
          appdata.listvalues.companyDropdownValues.map((item, key) => {

            if (item["BUKRS"] === vendordata.activeVendor.master.BUKRS) {
              if (!fromCompanySelected || fromCompanySelected["BUKRS"] != item["BUKRS"]) {
                setFromCompanySelected(item);
                dispatch(appdata_getVendorsForCompany(item["BUKRS"]));
              }
            }

            if (item["BUKRS"] === vendordata.activeVendor.master.BUKRS_NEW) {
              if (!toCompanySelected || toCompanySelected["BUKRS"] != item["BUKRS"]) {
                setToCompanySelected(item);
              }
            }
          });
        }


        if (
          appdata.listvalues.vendorsForCompany &&
          Object.keys(appdata.listvalues.vendorsForCompany).length > 0
        ) {
          appdata.listvalues.vendorsForCompany.map((item, key) => {
            if (item["LIFNR"] === vendordata.activeVendor.master.LIFNR) {
              if (!vendorSelected || vendorSelected["LIFNR"] != item["LIFNR"]) {
                setVendorSelected(item);
                dispatch(appdata_getPOsForVendor(fromCompanySelected.BUKRS, item["LIFNR"]));
              }
            }
          });
        }


        if (
          appdata.listvalues.POsForVendor &&
          Object.keys(appdata.listvalues.POsForVendor).length > 0
        ) {
          appdata.listvalues.POsForVendor.map((item, key) => {
            if (item["EKORG"] === vendordata.activeVendor.master.EKORG) {
              if (!fromPOSelected || fromPOSelected["EKORG"] != item["EKORG"]) {
                setFromPOSelected(item);
              }
            }

          });
        }
      }
    }

    else {
      if (fromCompanySelected) setFromCompanySelected("");
      if (toCompanySelected) setToCompanySelected("");
      if (vendorSelected) setVendorSelected("");
      if (fromPOSelected) setFromPOSelected("");
      if (kindOfChange) setKindOfChange("");
    }

    if (vendordata && vendordata.activeVendor && vendordata.activeVendor.master) {

      if (vendordata.activeVendor.master.EXTEND_TYPE) {
        if (kindOfChange != vendordata.activeVendor.master.EXTEND_TYPE) {
          setKindOfChange(vendordata.activeVendor.master.EXTEND_TYPE)
        }
      }
      else if (vendordata.activeVendor.master.REQ_TYP && kindOfChange != vendordata.activeVendor.master.REQ_TYP) {
        setKindOfChange(vendordata.activeVendor.master.REQ_TYP)
      }
    }


  }, [vendordata.activeVendor, appdata.listvalues])








  var toPOSelected = "";

  var typeOfRequest = "";

  if (vendordata.activeVendor.master) {

    appdata.listvalues.purchasingOrganisations.map((item, key) => {
      if (item["EKORG"] === vendordata.activeVendor.master.EKORG_NEW)
        toPOSelected = item;
    });

    appdata.listvalues.requestTypeDropdownValues.map((item, key) => {
      if (item["VALUE"] === vendordata.activeVendor.master.VEND_TYP)
        typeOfRequest = item;
    });






  }

  function handleChangeKind(event) {
    if (appdata.activeRequestType != event.target.value) {
      dispatch(
        appdata_setActiveRequestType(event.target.value)
      );
    }

    let key = appdata.isResetRequest ? "REQ_TYP" : "EXTEND_TYPE"

    dispatch(
      vendordata_updateActiveVendor({
        part: "master",
        key: key,
        value: event.target.value
      })
    );
  }

  function handleSelectChange(value, type = null) {
    // from company
    if (type == "BUKRS") {
      // clean active vendor
      if (!appdata.isResetRequest) {
        dispatch(vendordata_clearAllVendorData());
      }
      else {
        dispatch(
          vendordata_updateActiveVendor({
            part: "master",
            key: "LIFNR",
            value: ""
          })
        );
        setVendorSelected("");

      }

      // get vendors for company
      dispatch(appdata_getVendorsForCompany(value));
    }
    // vendor
    if (type == "LIFNR") {
      dispatch(appdata_getPOsForVendor(fromCompanySelected.BUKRS, value));
    }

    dispatch(
      vendordata_updateActiveVendor({
        part: "master",
        key: type,
        value: value
      })
    );
  }

  const showNOPOsWarning = () => {
    if (
      fromCompanySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] == ""
    ) {
      return true;
    }
    return false;
  };
  const showPOsDropdown = () => {
    if (
      fromCompanySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] != ""
    ) {
      return true;
    }
    return false;
  };

  const showVendorDropdown = () => {
    console.log('show vendor', fromCompanySelected)
    if (
      fromCompanySelected &&
      appdata.listvalues.vendorsForCompany &&
      Object.keys(appdata.listvalues.vendorsForCompany).length > 0
    ) {
      return true;
    }
    return false;
  };

  const allowSave = () => {

    console.log("vendordata.activeVendor.master", vendordata.activeVendor.master?.BUKRS_NEW)

    // as of 2025-10-22 we allow all requests to be saved without PO data
    //const allowSaveWithoutPurchasingOrganisation = vendordata.activeVendor.master && vendordata.activeVendor.master.BUKRS_NEW == "CN10" ? true : false;
    const allowSaveWithoutPurchasingOrganisation = true;


    if (
      vendordata.activeVendor.master &&

      vendordata.activeVendor.master.BUKRS &&
      vendordata.activeVendor.master.BUKRS_NEW &&
      vendordata.activeVendor.master.LIFNR &&
      (((showPOsDropdown() &&
        vendordata.activeVendor.master.EKORG &&
        vendordata.activeVendor.master.EKORG_NEW) || allowSaveWithoutPurchasingOrganisation) || showNOPOsWarning()) &&
      (vendordata.activeVendor.master.EXTEND_TYPE || vendordata.activeVendor.master.REQ_TYP)
    ) {
      return true;
    }
    return false;
  };

  const handleSave = () => {
    dispatch(appdata_setSnackbar({ open: true, message: "Saving..." }));
    dispatch(vendor_save_to_sap());
  };

  let containerClass = "no-breadcrumb chapter mt-4";
  if (!appdata.isResetRequest) {
    containerClass += " container-fluid"
  }


  if (vendordata.savedToSAP) {
    return (
      <Feedback header="Extend Vendor"></Feedback>
    );
  }

  return (
    <article className="article">
      <div className={containerClass}>

        {!appdata.isResetRequest && (
          <h2 className="article-title">Extend Vendor</h2>
        )}

        {appdata.isResetRequest && (
          <React.Fragment>
            <h2 className="article-title">
              Update Request
            </h2>
            <div className="mt-2">
              <b>Message: {vendordata.activeVendor.master.ZCOMMENT}</b>
            </div>
          </React.Fragment>
        )}


        <div className="mt-4">
          {/* extend from company */}
          {/* extend from company */}
          {/* extend from company */}
          {/* extend from company */}
          {/* extend from company */}
          {renderDropdown(
            "Extend from Company",
            appdata.listvalues.companyDropdownValues,
            fromCompanySelected,
            "BUKRS",
            "BUKRS",
            ["BUKRS", "BUTXT"],
            handleSelectChange
          )}

          {/* extend to company */}
          {/* extend to company */}
          {/* extend to company */}
          {/* extend to company */}
          {/* extend to company */}
          {showVendorDropdown() &&
            renderDropdown(
              "Extend to Company",
              appdata.listvalues.companyDropdownValues,
              toCompanySelected,
              "BUKRS_NEW",
              "BUKRS",
              ["BUKRS", "BUTXT"],
              handleSelectChange
            )}

          {/* vendor */}
          {/* vendor */}
          {/* vendor */}
          {/* vendor */}
          {/* vendor */}
          {showVendorDropdown() &&
            renderDropdown(
              "Vendor",
              appdata.listvalues.vendorsForCompany,
              vendorSelected,
              "LIFNR",
              "LIFNR",
              ["LIFNR", "NAME1"],
              handleSelectChange
            )}

          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {showNOPOsWarning() && (
            <div className="mt-4">
              <b>
                No Purchasing organisations found for vendor
              </b>
            </div>
          )}

          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {/* purchasing organisations */}
          {showPOsDropdown() &&
            renderDropdown(
              "Extend from Purchasing organisation",
              appdata.listvalues.POsForVendor,
              fromPOSelected,
              "EKORG",
              "EKORG",
              ["EKORG", "EKOTX"],
              handleSelectChange
            )}

          {showPOsDropdown() &&
            renderDropdown(
              "Extend to Purchasing organisation",
              appdata.listvalues.purchasingOrganisations,
              toPOSelected,
              "EKORG_NEW",
              "EKORG",
              ["EKORG", "EKOTX"],
              handleSelectChange
            )}

          {/* intercompany or third party */}
          {/* intercompany or third party */}
          {/* intercompany or third party */}
          {/* intercompany or third party */}
          {/* intercompany or third party */}
          {showVendorDropdown() && (
            <RadioGroup
              style={{ marginTop: 20 }}
              aria-label="gender"
              name="gender1"
              value={kindOfChange}
              onChange={handleChangeKind}
            >
              <FormControlLabel
                value={appdata.requestTypes.EXTEND_VENDOR_INTERCOMPANY}
                control={<Radio />}
                label="Intercompany"
              />
              <FormControlLabel
                value={appdata.requestTypes.EXTEND_VENDOR_THIRDPARTY}
                control={<Radio />}
                label="Third Party"
              />
            </RadioGroup>
          )}

          {/* thirdparty special */}
          {/* thirdparty special */}
          {/* thirdparty special */}
          {/* thirdparty special */}
          {/* thirdparty special */}
          {kindOfChange &&
            kindOfChange == appdata.requestTypes.EXTEND_VENDOR_THIRDPARTY &&
            renderDropdown(
              "Type of request",
              appdata.listvalues["requestTypeDropdownValues"],
              typeOfRequest,
              "VEND_TYP",
              "VALUE",
              ["VALUE", "DESCRIPTION"],
              handleSelectChange,
              20
            )}

          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {showVendorDropdown() && <FileUploader></FileUploader>}

          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {showVendorDropdown() && <FileViewer enableRemove={appdata.isResetRequest}></FileViewer>}

          {/* save button */}
          {/* save button */}
          {/* save button */}
          {/* save button */}
          {allowSave() && !vendordata.saving && (
            <Button
              className={classnames("besiButton", "d-print-none", "mt-5")}
              variant="contained"
              key="savebutton"
              onClick={() => handleSave()}
            >
              Save
            </Button>
          )}

          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {vendordata.saving && (
            <div className="mt-4">
              <Loader size="30"></Loader>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

export default Extend;
